export const formatNumber = (value, {
  minimumFractionDigits = 0,
  maximumFractionDigits = 1,
  ...options
} = {}) => {
  return Number(value).toLocaleString('pt-BR', {
    ...options,
    minimumFractionDigits,
    maximumFractionDigits,
  });
};

export function formatSocialNumberWithDecimal(rawNumber) {
  const thousand = 1000;
  const million = 1000000;

  if (rawNumber >= thousand && rawNumber < million) {
    return `${formatNumber(rawNumber / thousand)}k`;
  }

  if (rawNumber >= million) {
    return `${formatNumber(rawNumber / million)}M`;
  }
  return formatNumber(rawNumber);
}

export function removeHTMLTagsFromText(string) {
  return string.replace(/(<([^>]+)>)/gu, '');
}

export function removeSeparator(label) {
  return /(-+)/u.test(label) ? label.replace(/(.+-+)/gu, '') : label;
}

export function splitStringOnSeparator(string, separator) {
  if (!separator) {
    return string;
  }

  return string.split(separator)
    .filter(str => str.trim().length > 0);
}

export function stringDateToTimestamp(stringDate) {
  const [day, month, year] = stringDate.split('/');
  return new Date(year, month - 1, day).getTime();
}
